<template>
  <div class="workOrderAnalysis"
    v-loading="$store.state.user.loadingState">
    <AnalysisHead @getActiveTime="getActiveTime" />
    <div class="analysis ashComWrap">
      <div class="comTitle">
        <h4>工单分析</h4>
      </div>
      <div class="comContentBox"
        style="display: flex; justify-content: space-between">
        <div class="box1 secondAshComWrap">
          <div class="comTitle">
            <h4>总览</h4>
          </div>
          <div class="comContentBox">
            <div class="topBox">
              <AnalysisOverview :overviewData="overviewData" />
            </div>
            <div class="bottomBox">
              <PublicEcharts :id="'box2'"
                :chartsData="box1Data"
                :type="'pieChart'" />
            </div>
          </div>
        </div>
        <div class="box2 secondAshComWrap">
          <div class="comTitle">
            <h4>工单子系统分析</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts :id="'overview'"
              :chartsData="systemChart"
              :type="'stackedBar'" />
          </div>
        </div>
        <div class="box3 secondAshComWrap">
          <div class="comTitle">
            <h4>工单状态分析</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts :id="'box3'"
              :chartsData="stateData"
              :type="'ringChart'" />
          </div>
        </div>
        <div class="box4 secondAshComWrap">
          <div class="comTitle">
            <h4>工单来源分析</h4>
          </div>
          <div class="comContentBox">
            <!-- <RingChart :id="'box4'"
              :chartsData="sourceData" /> -->
            <PublicEcharts :id="'box4'"
              :chartsData="sourceData"
              :type="'ringChart'" />
          </div>
        </div>
      </div>
    </div>
    <AnalysisTwoChart :leftCharts="hoursCharts"
      :rightCharts="trendCharts"
      :leftTitle="'24小时工单趋势'"
      :rightTitle="rightTitle" />
    <AnalysisTable :title="'工单详情表'"
      :tabHead="tabHead"
      :tableData="tableData"
      :excelTitle="excelTitle"
      :showDownload="judgeAuthority('houqinguanli:workOrderAnalysis:export')" />
  </div>
</template>

<script>
import api from "@/api";
import {
  dateFtt,
  matchingOrderLevel,
  matchingOrderStatus,
  matchingOrderSource,
  judgeAuthority,
} from "@/assets/js/utils";
import AnalysisHead from "@/components/fenxizujian/AnalysisHead";
import AnalysisTwoChart from "@/components/fenxizujian/AnalysisTwoChart";
import AnalysisTable from "@/components/fenxizujian/AnalysisTable";
import AnalysisOverview from "@/components/fenxizujian/AnalysisOverview";
import PublicEcharts from "@/components/PublicEcharts";
export default {
  components: {
    AnalysisHead,
    AnalysisTwoChart,
    AnalysisTable,
    AnalysisOverview,
    PublicEcharts,
  },
  data() {
    return {
      rightTitle: "",
      tabHead: [
        { label: "时间", prop: "time" },
        { label: "工单数量", prop: "count" },
        { label: "紧急", prop: "HIGH" },
        { label: "重要", prop: "MEDIUM" },
        { label: "一般", prop: "LOW" },
        { label: "安全隐患", prop: "SAFETY_HAZARD" },
        { label: "待派单", prop: "TOBE_ASSIGNED" },
        { label: "待重新派单", prop: "TOBE_RE_ASSIGNED" },
        { label: "待处理", prop: "TOBE_REPAIR" },
        { label: "待确认", prop: "TOBE_CONFIRMED" },
        { label: "已完成", prop: "COMPLETED" },
        { label: "已关闭", prop: "INVALID" },
        { label: "H5上报", prop: "H5Reporting" },
        { label: "巡更上报", prop: "PatrolReport" },
        { label: "设备报警", prop: "EquipmentAlarm" },
        { label: "创建工单", prop: "createOrder" },
      ],
      tableData: [],
      hoursCharts: {
        unit: "条",
        type: "bar",
        xData: [],
        dataArr: [],
      },
      trendCharts: {
        unit: "条",
        type: "bar",
        xData: [],
        dataArr: [],
      },
      overviewData: {
        title: "工单数量",
        num: null,
        unit: "条",
        yoy: "",
        mom: "",
      },
      box1Data: { dataArr: [] },
      systemChart: {
        unit: "条",
        yData: [],
        dataArr: [],
      },
      stateData: {
        unit: "",
        dataArr: [],
      },
      sourceData: {
        unit: "",
        dataArr: [],
      },
      excelTitle: "",
    };
  },
  methods: {
    judgeAuthority,
    getActiveTime(val) {
      this.excelTitle = `工单分析-${val.timeValue ? val.timeValue : "全部"}`;
      this.$store.commit("SET_LOADING", true);
      if (val.type == "MONTH") {
        this.rightTitle = "每日工单趋势";
      } else if (val.type == "YEAR") {
        this.rightTitle = "每月工单趋势";
      } else {
        this.rightTitle = "每年工单趋势";
      }
      this.getOverview(val);
      this.getSystem(val);
      this.getStatus(val);
      this.getSource(val);
      this.getHourNumber(val);
      this.getOrderTrend(val);
      this.getTable(val);
      setTimeout(() => {
        this.$store.commit("SET_LOADING", false);
      }, 1000);
    },
    async getOverview(data) {
      this.box1Data.dataArr = [];
      this.overviewData.num = null;
      this.overviewData.yoy = null;
      this.overviewData.mom = null;
      let res = await api.logisticsWOANALOverview({
        type: data.type,
        date: data.timeValue,
      });
      if (res && res.data.code == 200) {
        this.overviewData.num = res.data.data.num;
        this.overviewData.yoy = res.data.data.yoy;
        this.overviewData.mom = res.data.data.mom;
        this.box1Data.dataArr = Array.from(res.data.data.charts).map(
          (item) => ({
            name: matchingOrderLevel(item.name),
            value: item.value,
          })
        );
      }
    },
    async getSystem(data) {
      this.systemChart.yData = [];
      this.systemChart.dataArr = [];
      let res = await api.logisticsWOANALSystem({
        type: data.type,
        date: data.timeValue,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        let arr = [];
        res.data.data.map((v) => {
          this.systemChart.yData.push(v.name);
          arr.push(v.charts);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.systemChart.dataArr.push({ name: "", data: [] });
          arr.map((item) => {
            this.systemChart.dataArr[i].name = matchingOrderLevel(item[i].name);
            this.systemChart.dataArr[i].data.push(item[i].value);
          });
        }
      }
    },
    async getStatus(data) {
      this.stateData.unit = "";
      this.stateData.dataArr = [];
      let res = await api.logisticsWOANALStatus({
        type: data.type,
        date: data.timeValue,
      });
      if (res && res.data.code == 200) {
        this.stateData.dataArr = Array.from(res.data.data).map((item) => ({
          name: matchingOrderStatus(item.name),
          value: item.value,
        }));
        this.stateData.unit = this.stateData.dataArr[0].unit ?? "";
      }
    },
    async getSource(data) {
      this.sourceData.unit = "";
      this.sourceData.dataArr = [];
      let res = await api.logisticsWOANALSource({
        type: data.type,
        date: data.timeValue,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.sourceData.dataArr = Array.from(res.data.data).map((item) => ({
          name: matchingOrderSource(item.name),
          value: item.value,
        }));
        this.sourceData.unit = this.sourceData.dataArr[0].unit ?? "";
      }
    },
    async getHourNumber(data) {
      this.hoursCharts.xData = [];
      this.hoursCharts.dataArr = [{ name: "24小时工单", data: [] }];
      let res = await api.logisticsWOANALHourNum({
        type: data.type,
        date: data.timeValue,
      });
      if (res && res.data.code == 200) {
        res.data.data.map((v) => {
          this.hoursCharts.xData.push(v.name);
          this.hoursCharts.dataArr[0].data.push(v.value);
        });
      }
    },
    async getOrderTrend(data) {
      this.trendCharts.xData = [];
      this.trendCharts.dataArr = [{ name: "工单数量", data: [] }];
      let res = await api.logisticsWOANALTrend({
        type: data.type,
        date: data.timeValue,
      });
      if (res && res.data.code == 200) {
        res.data.data.map((v) => {
          this.trendCharts.xData.push(
            data.type == "MONTH"
              ? dateFtt("dd日", new Date(v.ts))
              : data.type == "YEAR"
              ? dateFtt("MM月", new Date(v.ts))
              : dateFtt("yyyy年", new Date(v.ts))
          );
          this.trendCharts.dataArr[0].data.push(v.value);
        });
      }
    },
    async getTable(data) {
      this.tableData = [];
      let res = await api.logisticsWOANALTable({
        type: data.type,
        date: data.timeValue,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.tableData = res.data.data;
        this.tableData.map((v) => {
          v.time =
            data.type == "MONTH"
              ? dateFtt("dd日", new Date(v.ts))
              : data.type == "YEAR"
              ? dateFtt("MM月", new Date(v.ts))
              : dateFtt("yyyy年", new Date(v.ts));
        });
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.workOrderAnalysis {
  width: 100%;
  overflow: auto;
  .analysis {
    height: 400px;
    width: $innerWidth;
    margin: 0 auto;
    .box1 {
      width: 24%;
      height: 100%;
      .topBox {
        width: 85%;
        margin: 0 auto;
        height: 45%;
      }
      .bottomBox {
        width: 85%;
        margin: 0 auto;
        height: 55%;
      }
    }
    .box2,
    .box3,
    .box4 {
      width: 25%;
      height: 100%;
    }
  }
}
</style>